import React from 'react'
import { Icon } from '../../shared/ui/Icon'
import {
  CardContainer,
  CardIcon,
  CardContent,
  CardTitle,
  CardAmount
} from './EstimateSummaryCards.styles'

interface EstimateSummaryCardProps {
  title: string
  amount: number
  color: string
  iconType: 'document' | 'check-document' | 'dollar'
  iconBgColor: string
}

const formatAmount = (amount: number): string => {
  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  }).format(amount) + ' Р'
}

export const EstimateSummaryCard: React.FC<EstimateSummaryCardProps> = ({
  title,
  amount,
  iconType,
  iconBgColor,
  color = "#FFFFFF"
}) => {
  return (
    <CardContainer>
      <CardIcon bgColor={iconBgColor}>
        <Icon type={iconType} size={24} color={color} />
      </CardIcon>
      <CardContent>
        <CardTitle>{title}</CardTitle>
        <CardAmount>{formatAmount(amount)}</CardAmount>
      </CardContent>
    </CardContainer>
  )
}


